// src/components/Header/Header.js
import React from 'react';
import { Select } from 'common/components';
import './Header.css';

const Header = ({ isActive, onToggle, callStatus, dateFilter, onDateFilterChange }) => {
    return (
        <header className='agent-command-header'>
            <h1>Agent Command Center</h1>
            <div className='header-right'>
                <div className='date-selector'>
                    <Select
                        value={dateFilter}
                        onChange={(e) => onDateFilterChange(e.target.value)}
                        options={[
                            { value: 'today', label: 'Today' },
                            { value: 'yesterday', label: 'Yesterday' },
                            { value: 'last7days', label: 'Last 7 Days' },
                        ]}
                    />
                </div>
                <div className='active-toggle'>
                    <span>Inactive</span>
                    <label className='agent-toggle-switch'>
                        <input type='checkbox' checked={isActive} onChange={onToggle} />
                        <span className='agent-toggle-slider round'></span>
                    </label>
                    <span>Active</span>
                </div>
            </div>
        </header>
    );
};

export default Header;
